import { Mail, MapPin, Instagram, Music2, ArrowUpRight, Clock } from "lucide-react";

const STUDIO_EMAIL = "misslollydesigns@gmail.com";
const INSTAGRAM_URL = "https://www.instagram.com/misslollydesigns";

export default function Contact() {
  return (
    <div data-testid="contact-page" className="bg-ink">
      <section className="container-x section-y grid lg:grid-cols-12 gap-10">
        {/* LEFT — copy + studio details */}
        <div className="lg:col-span-5">
          <p className="overline">Get in touch</p>
          <h1 className="mt-4 font-display text-6xl md:text-7xl text-white">
            Say <span className="text-rose">hello.</span>
          </h1>
          <p className="mt-6 text-white/75 text-lg leading-relaxed">
            Workshop questions, party briefs, brand collabs or just a friendly hi —
            the studio inbox is always open.
          </p>

          <div className="mt-10 space-y-5">
            {[
              { i: MapPin, l: "Studio", v: "Hypha Studio, Walter Burke Way, Chatham, ME4 4RQ" },
              { i: Instagram, l: "Instagram", v: "@misslollydesigns" },
              { i: Music2, l: "TikTok", v: "@misslollydesigns" },
            ].map((row) => (
              <div key={row.l} className="flex gap-4 items-start">
                <div className="w-10 h-10 border-2 border-rose flex items-center justify-center text-rose flex-shrink-0">
                  <row.i size={16} />
                </div>
                <div>
                  <p className="text-[10px] uppercase tracking-[0.25em] text-gold font-bold">{row.l}</p>
                  <p className="text-white text-sm mt-0.5">{row.v}</p>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* RIGHT — primary email contact panel (no form) */}
        <div className="lg:col-span-7">
          <div
            data-testid="contact-email-panel"
            className="relative border-2 border-rose bg-coal p-8 md:p-12 overflow-hidden"
            style={{ boxShadow: "8px 8px 0 #FF2A70" }}
          >
            <div className="flex items-center gap-3">
              <Mail size={22} className="text-rose" />
              <p className="overline !text-rose">Direct email</p>
            </div>

            <h2 className="mt-5 font-display text-4xl md:text-5xl text-white leading-tight">
              For all enquiries,<br />
              <span className="text-rose">email directly.</span>
            </h2>

            <p className="mt-6 text-white/80 text-lg leading-relaxed">
              The fastest way to reach Miss Lolly is straight to the studio inbox.
              Workshop dates, custom denim briefs, party bookings — all handled
              personally by Lisa.
            </p>

            {/* Clickable mailto block */}
            <a
              href={`mailto:${STUDIO_EMAIL}`}
              data-testid="studio-mailto-link"
              className="group mt-10 block border-2 border-white bg-ink hover:bg-rose hover:border-rose transition-colors p-5 md:p-6"
              style={{ boxShadow: "4px 4px 0 #FFFFFF" }}
            >
              <p className="text-[10px] uppercase tracking-[0.28em] text-gold font-bold group-hover:text-white">
                Studio inbox
              </p>
              <p className="mt-2 font-display text-2xl md:text-3xl text-white break-all flex items-center gap-3">
                {STUDIO_EMAIL}
                <ArrowUpRight size={20} className="flex-shrink-0 opacity-70 group-hover:opacity-100 transition-opacity" />
              </p>
              <p className="mt-3 text-xs text-white/60 uppercase tracking-wider group-hover:text-white/85">
                Tap to open your mail app
              </p>
            </a>

            {/* Response time */}
            <div className="mt-8 flex items-start gap-3 text-white/75 text-sm leading-relaxed">
              <Clock size={16} className="text-gold flex-shrink-0 mt-0.5" />
              <p>
                I aim to respond within{" "}
                <span className="text-gold font-bold">24–48 hours</span>. For
                fastest replies, a DM on{" "}
                <a
                  href={INSTAGRAM_URL}
                  target="_blank"
                  rel="noreferrer"
                  data-testid="contact-instagram-link"
                  className="text-rose underline-offset-4 hover:underline"
                >
                  Instagram
                </a>{" "}
                also works.
              </p>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
